<div class="sign-in">
  <authentication-wrapper>
    <signin-stepper></signin-stepper>
  </authentication-wrapper>
</div>
